








































































































import { Component, Mixins, Prop } from "vue-property-decorator";
import _ from "@/boot/lodash";

// Mixins
import ImportInjectorMixin from "@/mixins/importInjectorMixin";

// Enums/Data
import { ImportStatusCodes } from "@/data/enums/imports";

// Types
import { IImportStep } from "@/models/imports";

@Component({
  components: {
    "step-mappings-provider": () =>
      import("@/components/app/admin/imports/stepMappingsProvider.vue"),
    "step-mappings-table": () =>
      import("@/components/app/admin/imports/stepMappingsTable.vue")
  }
})
export default class ImportStepBody extends Mixins(ImportInjectorMixin) {
  // Props

  @Prop({ required: true })
  public step!: IImportStep;

  // Methods

  public detachFile(fileId) {
    if (this.$importData.isStepProcessing) return;

    this.$importMethods.detachFile(
      this.step.id,
      _.map(
        this.$_.filter(this.step.files, stepFile => stepFile.id !== fileId),
        filteredStepFile => filteredStepFile.id
      )
    );
  }

  // Computed

  public get exportingMsgPath() {
    if (this.$_.isNull(this.step.estimated_completed_at))
      return "_sentence.imports.exporting_status_summary_completion_unknown_msg";
    return "_sentence.imports.exporting_status_summary_msg";
  }

  public get importingMsgPath() {
    if (this.$_.isNull(this.step.estimated_completed_at))
      return "_sentence.imports.importing_status_summary_completion_unknown_msg";
    return "_sentence.imports.importing_status_summary_msg";
  }

  public get timeRemaining() {
    return this.$moment
      .duration(this.step.estimated_remaining_seconds, "seconds")
      .humanize();
  }

  public get isExporting() {
    return [ImportStatusCodes.EXPORTING].includes(this.step.status.code);
  }

  public get isImporting() {
    return [ImportStatusCodes.IN_PROGRESS].includes(this.step.status.code);
  }

  public get showMappings() {
    return [ImportStatusCodes.MAPPINGS_REQUIRED].includes(
      this.step.status.code
    );
  }

  public get showCSVDataImportBody() {
    return (
      this.$importData.isCVSDataImport &&
      this.$importData.import.status.code !== ImportStatusCodes.CANCELLED
    );
  }
}
